var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('div',{staticClass:"page-fade-transition",class:[_vm.theme ? ("theme-" + _vm.theme) : '']},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-416b830a","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/transitions/fade-transition.vue
// module id = 3046
// module chunks = 0